import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { TextField, DateField, ImageField, Step } from '../SteppedForm';

import rules from './rules';

const StepPlatelic = (props) => {
  return (
    <Step
      id="platelic"
      title={'Vehicle - ' + (props.stateconfig().authName || props.stateconfig().plateName)}
      skip={(formdata) =>
        (formdata.vehicles[props.state.vehicle_index].plateOwnership !== 'own' &&
          !props.inStates(['vic', 'wa'])) ||
        formdata.onboardcar === false ||
        formdata.tiger === true
      }
      key={'platelic-' + props.state.formdata.state + '-' + props.getVehicle().plateOwnership}>
      {props.stateconfig().deferoperatorcred && (
        <Typography variant="body1">
          If you do not have accreditation, you will have to apply for Operator Accreditation (Small
          Passenger) with DPTI
        </Typography>
      )}
      <Grid container>
        {props.stateconfig().plate && (
          <>
            <Grid item xs={12} lg={6}>
              <TextField
                id="plate_number"
                label={props.stateconfig().plateName + ' #'}
                modify={(value) => props.toUpperCase(value)}
                valid={rules.alphanumeric}
                required
              />
            </Grid>
            {!props.stateconfig().plateExpiry && (
              <Grid item xs={12} lg={6}>
                <DateField
                  id="plate_exp"
                  label={props.stateconfig().plateName + ' Expiry'}
                  maxDate={
                    props.stateconfig().plateMaxDate
                      ? moment().add(props.stateconfig().plateMaxDate, 'months')
                      : undefined
                  }
                  minDate={moment()}
                  required
                />
              </Grid>
            )}
          </>
        )}

        {props.stateconfig().auth && (
          <>
            <Grid item xs={12} lg={6}>
              <TextField
                id="auth_number"
                label={props.stateconfig().authName}
                modify={(value) => props.toUpperCase(value)}
                valid={rules.safeText}
                required
              />
            </Grid>
            {!props.stateconfig().authExpiry && (
              <Grid item xs={12} lg={6}>
                <DateField
                  id="auth_exp"
                  label={props.stateconfig().authName + ' Expiry'}
                  maxDate={
                    props.stateconfig().authMaxDate
                      ? moment().add(props.stateconfig().authMaxDate, 'months')
                      : undefined
                  }
                  minDate={moment()}
                  required
                />
              </Grid>
            )}
          </>
        )}
      </Grid>

      <Grid container justify="space-around">
        {((props.getVehicle().plate !== '13cabs' && props.stateconfig().plateCert) ||
          props.stateconfig().authcert) && (
          <div style={{ width: '100%' }}>
            <h4>
              Please provide a copy of the documentation associated with this{' '}
              {props.stateconfig().plateName || props.stateconfig().authName}.
            </h4>
          </div>
        )}

        {props.getVehicle().plate !== '13cabs' && props.stateconfig().plateCert && (
          <Grid item>
            <ImageField
              label={
                props.stateconfig().plateName ? props.stateconfig().plateName : 'Plate Certificate'
              }
              id="plate_cert"
              height={194}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
              acceptAll
              required
            />
          </Grid>
        )}

        {props.stateconfig().authCert && (
          <Grid item>
            <ImageField
              label={props.stateconfig().authName}
              id="auth_cert"
              height={194}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
              acceptAll
              required
            />
          </Grid>
        )}
      </Grid>
    </Step>
  );
};

export default StepPlatelic;
